import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=4a353df5"
import script from "./Spinner.vue?vue&type=script&setup=true&lang=js"
export * from "./Spinner.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports